import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Homepage } from "./homepage/Homepage";
import { TrafikBasvuru } from "./basvuru/TrafikBasvuru";
import { KaskoBasvuru } from "./basvuru/KaskoBasvuru";
import { SaglikBasvuru } from "./basvuru/SaglikBasvuru";
import { DaskBasvuru } from "./basvuru/DaskBasvuru";
import { SeyahatBasvuru } from "./basvuru/SeyahatBasvuru";
import { KayitPage } from "./pages/KayitPage";
import { Placeholder } from "./pages/Placeholder";

// WEB1 — the public marketing site. WEB3 lands the teklif-TALEBİ akışı for ALL FIVE product
// lines: every homepage product card reaches its own real 2-step flow, responsive
// (masaüstü wide card + mobil telefon düzeni). Request-first — each flow POSTs to the PUBLIC
// intake endpoint (/v1/public/quote-requests) at the kişisel-bilgiler boundary, then lands on
// the terminal "Talebiniz alındı" A4 (NO instant price/quote — the advisor prepares the 3–4
// offers afterwards); an optional "Kayıt ol" opens the self-serve account. The "Yakında"
// Placeholder is retired for the advisor CTAs too: the old dead /danisman "Faz 2" stub is
// removed and every advisor-match CTA starts the real trafik funnel. No-instant-price moat kept.
export function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/basvuru/trafik" element={<TrafikBasvuru />} />
        <Route path="/basvuru/kasko" element={<KaskoBasvuru />} />
        <Route path="/basvuru/saglik" element={<SaglikBasvuru />} />
        <Route path="/basvuru/dask" element={<DaskBasvuru />} />
        <Route path="/basvuru/seyahat" element={<SeyahatBasvuru />} />
        <Route path="/kayit" element={<KayitPage />} />
        <Route path="/basvuru/:urun" element={<Placeholder />} />
        <Route path="*" element={<Homepage />} />
      </Routes>
    </BrowserRouter>
  );
}
